<template>
    <b-container fluid>
        <b-breadcrumb :items="breadcrumbItems" class="minus-gutters"></b-breadcrumb>
         <b-alert :show="messageObject.success.count"
                dismissible
                @dismissed="messageObject.success.count=0"
                @dismiss-count-down="successCountChanged"
                >{{messageObject.success.content}}
        </b-alert>
        <b-alert :show="messageObject.warning.count"
                variant="danger"
                dismissible
                @dismissed="messageObject.warning.count=0"
                @dismiss-count-down="warningCountChanged"
                >{{messageObject.warning.content}}
        </b-alert>
        <b-alert :show="ifshow && account.group.value != '4'" variant="danger">此帳號尚未開通，稍後系統管理員確認身分後將為您進行開通，謝謝！</b-alert>
        <b-alert :show="ifshow && account.group.value == '4'" variant="danger">此帳號尚未開通，請登入您的信箱開啟驗證信並點擊啟用帳號連結，如驗證信過期或未收到驗證信，請使用重發驗證信功能</b-alert>
        <b-row align-h="center">
            <b-col md="5">
                <h2>個人資料維護</h2>
                <b-form-group :label="disposable_line_show?'Line ID：':'E-mail 帳號：'">
                    <b-form-input
                        id="profile-email"
                        v-model="account.email.value"
                        type="text"
                        disabled
                    >
                    </b-form-input>
                </b-form-group>
                 <b-form-group v-show="!disposable_line_show" class="text-primary" label="訂閱農作物交易行情及氣象預警通知：">
                     <b-form-checkbox
                        id="profile-subscrible"
                        v-model="account.subscribile.value"
                        switch
                        >
                    </b-form-checkbox>
                </b-form-group>
                <!-- <b-row class>
                    <b-col sm="5">
                        <label for="input-none">訂閱農作物交易行情及氣象預警通知：</label>
                    </b-col>
                    <b-col>
                        <b-form-checkbox
                        id="profile-subscrible"
                        v-model="account.subscribile.value"
                        switch
                        >
                        </b-form-checkbox>
                    </b-col>
                </b-row> -->
                <b-form-group label="姓名：">
                    <b-form-input
                        id="profile-name"
                        v-model="account.fullname.value"
                        :state="account.fullname.state"
                        aria-describedby="profile-name-feedback"
                        type="text"
                        @input="fullnameverify"
                        required>
                    </b-form-input>
                    <b-form-invalid-feedback id="profile-name-feedback">
                        {{account.fullname.message}}
                    </b-form-invalid-feedback>
                </b-form-group>
                <b-form-group label="單位：">
                    <b-form-input
                        id="profile-unit"
                        v-model="account.unit.value"
                        type="text"
                        required
                    >
                    </b-form-input>
                </b-form-group>
                <b-form-group label="職稱：">
                    <b-form-input
                        id="profile-role"
                        v-model="account.role.value"
                        type="text"
                        required
                    >
                    </b-form-input>
                </b-form-group>
                <b-form-group label="電話：">
                    <b-form-input
                        id="profile-tel"
                        v-model="account.tel.value"
                        type="text"
                        required
                    >
                    </b-form-input>
                </b-form-group>
                <!-- <b-form-group label="分機：">
                    <b-form-input type="text" required></b-form-input> -->
                <!-- </b-form-group> -->
                <b-form-group label="群組：">
                    <b-form-input
                        id="profile-group"
                        type="text"
                        :value="grouplist[account.group.value] || ''"
                        disabled
                    >
                    </b-form-input>
                </b-form-group>
                <span class="text-info" v-if="ifresend" v-b-modal.modal-resendemail>重新發送驗證信</span>
                <b-modal
                id="modal-resendemail"
                ref="resendemailmodal"
                title="是否重新發送驗證信?"
                @ok="handleresendEmailOk"
                >
                <form ref="form" @submit.stop.prevent="handleSubmit">
                    <b-form-group
                    label="您的Email"
                    label-for="email-input"
                    >
                    <b-input-group size="lg">
                    <b-input-group-prepend is-text>
                    <b-icon icon="envelope"></b-icon>
                    </b-input-group-prepend>
                    <b-form-input
                        id="email-input"
                        v-model="account.email.value"
                        disabled
                    ></b-form-input>
                    </b-input-group>
                    </b-form-group>
                </form>
                </b-modal>
                <b-button @click="modifedFunction" block size="lg" variant="primary">確定修改</b-button>
            </b-col>
        </b-row>
        <b-modal id="modal-editsave" ref="editsavemmodal" title="儲存修改" @ok="handlEditSave">
            是否儲存修改內容
        </b-modal>
    </b-container>
</template>
<script>
    export default {
        data() {
            return {
                //判別為Line免洗帳號
                disposable_line_show: false,
                breadcrumbItems: [{
                        text: '首頁',
                        href: '#'
                    },
                    {
                        text: '個人資料維護',
                        active: true
                    }
                ],
                ifshow: false,
                ifresend: false,
                account: {
                    AC_STATUS: null,
                    AC_ID: null,
                    email: {
                        value: "",
                        state: null
                    },
                    fullname: {
                        value: "",
                        state: null,
                        message: "欄位不能空白"
                    },
                    unit: {
                        value: "",
                        state: null
                    },
                    role: {
                        value: "",
                        state: null
                    },
                    tel: {
                        value: "",
                        state: null
                    },
                    group: {
                        value: "",
                        state: null
                    },
                    subscribile: {
                        value: ""
                    }
                },
                messageObject:
                {
                        warning:
                        {
                        //show: false,
                        content: null,
                        count: 0
                        },
                        success:
                        {
                            content: null,
                            count: 0
                        },
                        dismissSecs: 5,
                },
                grouplist: [],
                apiGetAccountSelf: (data) => this.userRequest.post("/API/Default/GetAccountSelf", data),
                apiUpdateAccountSelf: (data) => this.userRequest.post("/API/Default/UpdateAccountSelf", data),
                apiAccountGroupGetList: (data) => this.userRequest.post("/API/Default/AccountGroupGetList", data),
                apiResendCertification: (data) => this.userRequest.post("/API/Default/ResendCertification", data)
            }
        },
        created() {
            this.checkLogin()
        },
        methods: {
            getAccountGroupGetList(data){
                this.apiAccountGroupGetList(data)
                    .then((res)=>{
                        const json = JSON.parse(res.data)
                        // this.imageObj = json.Data
                        this.grouplist = JSON.parse(json.Data)
                        this.FunctionToken(this.getAccountSelf, {})
                    })
                    .catch((err)=> {
                        console.log(err)
                    });
            },
            getAccountSelf(data) {
                // console.log(data)
                this.apiGetAccountSelf(data)
                .then((res)=>{
                    const json = JSON.parse(res.data)
                    // console.log(json)
                    if(json.Status){
                        let jsonData = json.Data
                        // console.log(jsonData)
                        this.datamapping(JSON.parse(jsonData))
                    }
                })
                .catch((err)=> {
                    console.log(err)
                });
            },
            upDateAccountSelf(data) {
                // console.log(data)
                this.apiUpdateAccountSelf(data)
                .then((res)=>{
                    const json = JSON.parse(res.data)
                    // console.log(json)
                    if(json.Status){
                        // this.$router.push('/')
                        this.suceessPopUp('個人資料已儲存成功')
                    }
                })
                .catch((err)=> {
                    console.log(err)
                });
            },
            setResendCertification(data)
            {
                // console.log(data)
                this.apiResendCertification(data)
                .then((res)=>{
                    const json = JSON.parse(res.data)
                    // console.log(json)
                    if(json.Status){
                        this.$nextTick(() => {
                        this.$bvModal.hide('modal-resendemail')
                        this.suceessPopUp("已傳送驗證信到該信箱")
                    })
                    }
                    else
                    {
                    this.$bvModal.hide('modal-resendemail')
                    this.waningPopUp(json.Data)
                    }
                })
                .catch((err)=> {
                    console.log(err)
                });
            },
            checkLogin() {
                let TokenID = sessionStorage.getItem("TokenID");
                let disposable_line = sessionStorage.getItem("disposable_line");
                // console.log(TokenID)
                if(TokenID){
                    if(disposable_line){ this.disposable_line_show = true; }
                    this.FunctionToken(this.getAccountGroupGetList, {});
                }
                else
                {
                    alert("未有權限檢視此頁面，請登入帳號")
                    this.$router.push({ path: '/login' })
                }
            },
            datamapping(item)
            {
                this.account = {
                    AC_STATUS: item.AC_STATUS,
                    AC_ID: item.AC_ID,
                    email: {
                        value: item.AC_USERID,
                    },
                    fullname: {
                        value: item.AC_USERNAME,
                        state: null,
                        message: "欄位不能為空值"
                    },
                    unit: {
                        value: item.AC_CONTENT,
                        state: null
                    },
                    role: {
                        value: item.AC_TITLE,
                        state: null
                    },
                    tel: {
                        value: item.AC_TEL,
                        state: null
                    },
                    group: {
                        value: item.AC_GROUP_ID,
                        state: null
                    },
                    subscribile: {
                        value: item.AC_NOTIFY
                    }
                }
                if(item.AC_STATUS==0)
                {
                    this.ifshow=true
                    if(parseInt(item.AC_GROUP_ID)==4) {
                        this.ifresend=true
                    }
                }
            },
            modifedFunction() {
                this.$refs['editsavemmodal'].show()
            },
            handlEditSave() {
                let obj={
                    "AC_USERNAME": this.account.fullname.value,
                    "AC_TEL": this.account.tel.value,
                    "AC_TITLE": this.account.role.value,
                    "AC_CONTENT": this.account.unit.value,
                    "AC_NOTIFY": this.account.subscribile.value,
                }
                this.FunctionToken(this.upDateAccountSelf, obj)
            },
            suceessPopUp(msg){
                this.messageObject.success.count = this.messageObject.dismissSecs
                this.messageObject.success.content = msg
            },
            successCountChanged(count)
            {
                this.messageObject.success.count = count
            },
            waningPopUp(msg){
                this.messageObject.warning.count = this.dismissSecs
                this.messageObject.warning.content = msg
            },
            warningCountChanged(count) {
                this.messageObject.warning.count = count
            },
            handleresendEmailOk(bvModalEvt) {
                bvModalEvt.preventDefault()
                // Trigger submit handler
                this.handleRendEmail()
            },
            handleRendEmail() {
                let item= {
                "AC_USERID": this.account.email.value
                }
                this.FunctionToken(this.setResendCertification, item)
            },
            fullnameverify() {
                this.account.fullname.state = this.IsNull(this.account.fullname.value)==''?false:true
            }
        }
    }
</script>